import { AssistantDirectionSharp } from "@mui/icons-material";
import { Alert, Box, Button, Card, Grid, Input, Option, Select, Stack, Typography } from "@mui/joy";
import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';


function ClosetRoomPage() {
    var url = useSelector((state) => state.rpc.servidorUrl)
    var token = useSelector((state) => state.auth.token)
    var [form, setForm] = useState({
        query: "",
        tipo: "TODOS",
        resultados: [],
        itensNoCloset: []
    })
    var [personagemForm, setPersonagemForm] = useState({
        nome: "",
        error: null,
        saving: false,
        link: null
    })

    const salvarPersonagem = async () => {

        setPersonagemForm({ ...personagemForm, error: null, saving: true, link: null })
        const formData = new FormData();
        const formToSend = {
            action: "CASTOR_NOVO_PERSONAGEM_CLOSET_RPC",
            runNow: true,
            payload: JSON.stringify({
                nome: personagemForm.nome,
                imagens: form.itensNoCloset.map(e => e.imagemId),
            })
        }

        formData.append("file", null);
        formData.append(
            "data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json",
            })
        );

        try {
            var r = await axios.post(url + "/rpc", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${token}`,
                }
            });

            setPersonagemForm({
                ...personagemForm, error: "Salvo", saving: false,
                link: r.data.payload.imagemUriP50
            })


            //   setForm({...form, error :  "UPLOAD realizado!", enviando : false})
        } catch (error) {
            setPersonagemForm({ ...personagemForm, error: "Deu ruim", saving: false })
            console.log(error)
        }

    }

    const updateQuery = (value) => {
        setForm({ ...form, query: value })
    }
    const adicionar = item => {
        var itens = [...form.itensNoCloset, { ...item }]
        setForm({ ...form, itensNoCloset: itens })
    }

    const doSearch = async () => {
        const formData = new FormData();
        const formToSend = {
            action: "CLOSET_BUSCA_ITENS_CLOSET_RPC",
            runNow: true,
            payload: JSON.stringify({
                query: form.query,
                tipo: form.tipo,
            })
        }

        formData.append("file", null);
        formData.append(
            "data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json",
            })
        );

        try {
            var r = await axios.post(url + "/rpc", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${token}`,
                }
            });

            setForm({ ...form, resultados: r.data.payload })


            //   setForm({...form, error :  "UPLOAD realizado!", enviando : false})
        } catch (error) {
            console.log(error)
        }
    }

    const atualizaTipo = async (value) => {

        setForm({ ...form, tipo: value })
        //  doSearch()
    }

    const remove = item => {
        var itens = [...form.itensNoCloset].filter(i => i !== item)
        setForm({ ...form, itensNoCloset: itens })
    }

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(form.itensNoCloset);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setForm({ ...form, itensNoCloset: items });
    };
    return (
        <Grid container alignItems="flex-start" sx={{ height: "80vh", overflow: "hidden" }}>
            <Grid xs={12} sx={{ padding: 2 }}>
                <Stack spacing={2} direction="row" sx={{ height: "100%" }}>
                <Link to="/closet/add-item" sx={{ width: "100%" }}>
                        <Button color="primary" sx={{ width: "100%" }}>Registrar novo item</Button>
                    </Link>
                    <Link to="/closet/personagens" sx={{ width: "100%" }}>
                        <Button color="primary" sx={{ width: "100%" }}>Personagens</Button>
                    </Link>
                </Stack>
            </Grid>
            <Grid container xs={12}>
                <Grid xs={3} sx={{
                    padding: 2,
                    height: '80vh', // Define a altura do grid como 100% do viewport
                    overflow: 'hidden',
                }} overflow={true}>
                    <Box sx={{ height: "100%", overflow: "hidden" }}>
                        <Stack spacing={2} sx={{ height: "100%" }}>
                            <Stack direction="row" spacing={1}>
                                <Input type="text" value={form.search} onChange={
                                    (e) => updateQuery(e.target.value)
                                }></Input>
                                <Button color="primary" onClick={doSearch}>Go</Button>
                            </Stack>
                            <Select value={form.tipo} onChange={(e, value) => atualizaTipo(value)}>
                                <Option value="TODOS">Todos</Option>
                                <Option value="CABELO">Cabelo</Option>
                                <Option value="ROSTO">Rosto</Option>
                                <Option value="ROUPA">Roupa</Option>
                            </Select>
                            <Box sx={{ maxHeight: "70%", overflowY: "auto" }} >
                                <Grid container >


                                    {form.resultados.map(e => {
                                        return <Grid xs={6} sx={{ padding: 0.5 }}>
                                            <Card>
                                                <Stack spacing={1}>
                                                    <Typography>
                                                        <b>{e.tipo}</b>
                                                    </Typography>
                                                    <img src={url + "/api/public/imgur/" + e.imagemUriP10} alt={e.nome} title={e.nome} />
                                                    <Button color="danger" onClick={() => adicionar(e)}>Adicionar</Button>
                                                </Stack>
                                            </Card>
                                        </Grid>
                                    })}

                                </Grid>
                            </Box>
                        </Stack>
                    </Box>
                </Grid>
                <Grid
                    xs={6}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 2,
                        height: '100vh', // Ocupa a altura total do viewport
                        position: 'relative', // Contêiner relativo para posicionamento absoluto dos filhos
                    }}
                >
                    <Box
                        sx={{
                            position: 'absolute', // Posicionamento absoluto em relação ao Grid
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%', // Preenche a área do Grid
                            // backgroundColor: 'rgba(255, 0, 0, 0.5)', // Transparência para sobreposição
                        }}
                    >
                        <center>
                            <img
                                src={url + "/api/public/imgur/a2860579-nu-sem-maos-p25.png"}
                                alt="Imagem"
                                style={{
                                    maxWidth: "500px",
                                    objectFit: "contain",
                                }}
                            />
                        </center>
                    </Box>
                    {form.itensNoCloset.map(e => {

                        return <Box
                            sx={{
                                position: 'absolute', // Posicionamento absoluto em relação ao Grid
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%', // Preenche a área do Grid
                                // backgroundColor: 'rgba(0, 255, 0, 0.5)', // Transparência para sobreposição
                            }}
                        >
                            <center>
                                <img
                                    src={url + "/api/public/imgur/" + e.imagemUriP25}
                                    alt="Imagem"
                                    style={{
                                        maxWidth: "500px",
                                        objectFit: "contain",
                                    }}
                                />
                            </center>
                        </Box>
                    })}
                </Grid>
                <Grid xs={3}>
                    <Stack spacing={1}>
                        <Card>
                            <Stack spacing={1}>
                                <Alert color={personagemForm.error != null ? "danger" : "primary"}>
                                    {personagemForm.error}
                                    {personagemForm.link && <Link to={url + "/api/public/imgur/" + personagemForm.link} target="_blank"> Link para imagem <Link />
                                    </Link>}
                                </Alert>
                                <Input placeholder="Personagem" type="text" value={personagemForm.nome} onChange={(e) => { setPersonagemForm({ ...personagemForm, nome: e.target.value }) }} disabled={personagemForm.saving} />
                                <Button onClick={salvarPersonagem} disabled={personagemForm.saving}>Salvar</Button>
                            </Stack>
                        </Card>
                        <Typography>Itens selecionados</Typography>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="closetItems">
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        {form.itensNoCloset.map((e, index) => (
                                            <Draggable key={e.nome} draggableId={e.nome} index={index}>
                                                {(provided) => (
                                                    <Card
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                            marginBottom: '8px',
                                                            ...provided.draggableProps.style,
                                                        }}
                                                    >
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography>
                                                                <b>{e.tipo}:</b> {e.nome}
                                                            </Typography>
                                                            <Button color="danger" onClick={() => remove(e)}> X </Button>
                                                        </Stack>
                                                    </Card>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Stack>
                </Grid>
            </Grid>
        </Grid>
    );

}

export default ClosetRoomPage;

